import { createFileRoute } from "@tanstack/react-router";

import { ProductsSettings } from "../features/settings/ProductsSettings";
import { useT } from "../i18n/I18nProvider";

export const Route = createFileRoute("/app/settings/products")({
  // `product` opens that product's form: the ad copy page links here when the product it
  // was asked to write for has nothing to write from yet.
  validateSearch: (search: Record<string, unknown>): { product?: string } =>
    typeof search.product === "string" ? { product: search.product } : {},
  component: ProductsPage,
});

function ProductsPage() {
  const t = useT();
  const { product } = Route.useSearch();
  return (
    <>
      <h2>{t("settings.products.title")}</h2>
      <ProductsSettings initial={product} />
    </>
  );
}
